import { Injectable } from '@angular/core';

import { TokensSummaryService } from '../../../../lib/tokens-base/tokens-summary.service';
import { ISlipSummary } from '../../summary/models';
import { IRewardToken, OddsBoostToken, RiskFreeToken } from '../reward-tokens.model';
import {
    calculateWinningsBoost,
    isAccaBoostToken,
    isBetAndGetToken,
    isIncrementalPayoutEligible,
    isOddsBoostToken,
    isRiskFreeToken,
} from './reward-tokens.utils';

@Injectable({ providedIn: 'root' })
export class RewardTokensBetslipSummaryService {
    constructor(private tokensSummaryService: TokensSummaryService) {}

    getTokenSummary(token: IRewardToken, summary: ISlipSummary | undefined): string | null {
        if (!summary) {
            return null;
        }

        const noOfSlabs = isIncrementalPayoutEligible(token, summary.totalStake?.toNumber()) ? token.incrementalPayoutNoOfTimes : 1;

        if (isOddsBoostToken(token)) {
            return this.getOddsBoostMessage(token, summary);
        }

        if (isRiskFreeToken(token)) {
            return this.getRiskFreeMessage(token, summary, noOfSlabs);
        }

        if (isBetAndGetToken(token)) {
            return this.tokensSummaryService.getBetAndGetSummary(token);
        }

        if (isAccaBoostToken(token)) {
            const pickCount = Object.keys(summary.slip.slipPicks).length;

            return this.tokensSummaryService.getAccaBoostSummary(token, pickCount);
        }

        return null;
    }

    private getOddsBoostMessage(token: OddsBoostToken, summary: ISlipSummary): string | null {
        const winningsBoost = calculateWinningsBoost(summary);

        return this.tokensSummaryService.getBoostedWinningsSummary(token.payoutType, winningsBoost);
    }

    private getRiskFreeMessage(token: RiskFreeToken, summary: ISlipSummary, noOfSlabs?: number): string | null {
        return this.tokensSummaryService.getRiskFreeSummary(
            token.payoutType,
            token.maximumPayout,
            token.riskFreePercentage,
            summary.totalStake?.toNumber(),
            noOfSlabs,
        );
    }
}
